import * as yup from "yup";

export const schema = yup.object().shape({
  category: yup.string(),
});
export const unitOfMeasureSchema = yup.object().shape({
  unitOfMeasureName: yup.string().required("Name is required field"),
  baseOfUnitOfMeasure: yup
    .string()
    .required("Base Unit of measure is required field"),
  CFB: yup.number().required("Conversion Factor base is required field"),
});

export const unitOfMeasureUpdateSchema = yup.object().shape({
  unitOfMeasureName: yup.string().required("Name is required field"),
  baseOfUnitOfMeasure: yup
    .string()
    .required("Base Unit of measure is required field"),
  CFB: yup.number().required("Conversion Factor base is required field"),
});

export const productShcema = yup.object().shape({
  title: yup.string().required("Title of product is required").min(4),
  category: yup.string().required("This Field is required"),
  price: yup.number().required("This Field is required"),
  unit: yup.string().required("This Field is required"),
});

export const userSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required")
    .matches(/^\S*$/, "Whitespace is not allowed"),
});

export const testSchema = yup.object().shape({
  testField: yup.string().required("TEST ERROR"),
});
